import React from 'react';
import { Button, Image, Space } from 'antd';
import { LuDownload, LuRefreshCw, LuImage } from 'react-icons/lu';

export default function ResultCard({ image, downloadLabel, regenerateLabel, onDownload, onRegenerate }) {
  return (
    <div className="result-wrapper">
      <div className="result-card">
        {/* Result Header */}
        <div className="result-header">
          <LuImage className="result-icon" />
          <h2 className="result-title">Genereeritud pilt</h2>
        </div>
        
        {/* Generated Image */}
        <div className="result-image-container">
          <Image preview src={image} alt="Genereeritud tulemus" className="result-image" />
        </div>
        
        {/* Action Buttons */}
        <div className="result-actions">
          <Button 
            type="primary" 
            icon={<LuDownload className="action-icon" />} 
            onClick={onDownload}
            className="download-btn"
            size="large"
            style={{ width: "200px", height: "40px" }}
          >
            {downloadLabel}
          </Button>
          <Button 
            icon={<LuRefreshCw className="action-icon" />} 
            onClick={onRegenerate}
            className="regenerate-btn"
            size="large"
            style={{ width: "200px", height: "40px" }}
          >
            {regenerateLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}


